import moment from "moment";
import { useTranslation } from "react-i18next";

const defaultRender = (value) => (value ? value : "0.00");
const useJournalCell = () => {
    const { t } = useTranslation();

    const formatDateTime = (isoTime) => {
        if (!isoTime) return "--";
        return moment(isoTime).format("DD-MM-YYYY HH:mm:ss");
    };
    return [
        { title: t("time"), width: '20%',dataIndex: 'time', render: (value) => formatDateTime(value), },
        { title: t("message"),width: '80%', dataIndex: 'message', render: defaultRender, },

    ];
};

export default useJournalCell;
